const processData = [
  {
    order: "01",
    type: "Research",
    title: "Strategy & Blueprint",
    description:
      "We start by anchoring your vision in research, market analysis, and clear product strategy. This step is all about removing ambiguity, defining measurable goals, and creating the foundational blueprint for success.",
  },
  {
    order: "02",
    type: "Design",
    title: "Bringing Ideas to Life",
    description:
      "From wireframes to prototypes and design systems, we build user interfaces and experiences that are intuitive, accessible, and ready to scale.",
  },
  {
    order: "03",
    type: "Development",
    title: "Precision Engineering",
    description:
      "Your vision meets our expertise. Through clean code and modern frameworks, we deliver frontend and backend solutions that are fast, reliable, and built to perform.",
  },
  {
    order: "04",
    type: "Growth",
    title: "Driving Results",
    description:
      "We don't just build websites; we create opportunities for your business. Our solutions expand your reach, boost engagement, and drive conversions.",
  },
  {
    order: "05",
    type: "Support",
    title: "Staying Ahead",
    description:
      "Our work doesn't end at launch. We provide lasting systems and support to keep your business ahead and ready for what's next.",
  },
];

export default processData;
